import styled from 'styled-components';

const Container = styled.div`
  height: 30px;
  background-color: teal;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
`;

function Announcement() {
  return <Container>Deal of the day! Flat 10% off on order above 5000 bucks.</Container>;
}

export default Announcement;
